import React, { useState } from 'react';
import history from '@send-legacy-app/history';

export const useTrackingId = () => {
  const [trackingId, setTrackingId] = useState<null | string>(null);
  const acceptedParams = ['source', 'mozo_id', 'cid', '_ctmtransaction_id'];

  React.useEffect(() => {
    const { search } = history.location;
    const queryList = search?.split?.('?') || [];

    queryList.forEach((query) => {
      const params = new URLSearchParams(query);

      params.forEach((value, key) => {
        if (acceptedParams.includes(key)) {
          setTrackingId(value);
        }
      });
    });
  }, []);

  return trackingId;
};
